import { createRouter, createWebHistory } from 'vue-router';
// import store from '@/store'; // Vuexストアをインポート
import LoginPage from '@/components/LoginPage';
import ArticleManagement from '@/components/ArticleManagement';
import ChannelManagement from '@/components/ChannelManagement';
import ArticleSettings from '@/components/ArticleSettings';
import ArticlePreview from '@/components/ArticlePreview';
import ChannelInvitation from '@/components/ChannelInvitation';
import AccountCreation from '@/components/AccountCreation';
import AccountCreated from '@/components/AccountCreated';
import ChannelApplicationForm from '@/components/ChannelApplicationForm';
import ChannelApplicationWaiting from '@/components/ChannelApplicationWaiting';
import ChannelApplicationPending from '@/components/ChannelApplicationPending';
import ChannelApplicationRejected from '@/components/ChannelApplicationRejected';
import UserGuideline from '@/components/UserGuideline';
import Information from '@/components/InformationTable';
import InformationDetails from '@/components/InformationDetails';
import MemberManagement from '@/components/MemberManagement';
import { isLogin } from '../composables/userCheckAuth'
import { isGuideline } from '../composables/userCheckGuideline'
import { resolveApplicationRedirect, ensureApplicationStatus } from '../composables/userCheckApplication'

const routes = [
  // '/' は Django が LP を返すため、SPAのルーティングには到達しない（project/urls.py 参照）
  {
    path: '/login',
    name: 'Login',
    component: LoginPage, //ログインページのため、非ログイン時の制御はしない。
  },
  {
    path: '/article-management',
    name:'ArticleManagement',
    component: ArticleManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/channel-management',
    name:'ChannelManagement',
    component: ChannelManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/articles/settings/:id',
    name: 'ArticleSettings',
    component: ArticleSettings,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/articles/settings/:id/preview',
    name:'ArticlePreview',
    component: ArticlePreview,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/channel-invitation',
    name: 'ChannelInvitation',
    component: ChannelInvitation,
    meta: { requiresAuth: true }
  },
  {
    path: '/account-creation',
    name: 'AccountCreation',
    component: AccountCreation,
  },
  {
    path: '/account-created',
    name: 'AccountCreated',
    component: AccountCreated,
    meta: { requiresAuth: true }
  },
  // #301: CS審査フロー専用ルート群
  {
    path: '/channel-application/form',
    name: 'ChannelApplicationForm',
    component: ChannelApplicationForm,
    meta: { requiresAuth: true }
  },
  {
    path: '/channel-application/waiting',
    name: 'ChannelApplicationWaiting',
    component: ChannelApplicationWaiting,
    meta: { requiresAuth: true }
  },
  {
    path: '/channel-application/pending',
    name: 'ChannelApplicationPending',
    component: ChannelApplicationPending,
    meta: { requiresAuth: true }
  },
  {
    path: '/channel-application/rejected',
    name: 'ChannelApplicationRejected',
    component: ChannelApplicationRejected,
    meta: { requiresAuth: true }
  },
  {
    path: '/guideline',
    name: 'UserGuideline',
    component: UserGuideline
  },
  {
    path: '/information',
    name: 'Information',
    component: Information,
    meta: { requiresAuth: true }
  },
  {
    path: '/information/details/:id/',
    name:'InformationDetails',
    component: InformationDetails,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/member-management',
    name: 'MemberManagement',
    component: MemberManagement,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*', // すべての未定義のパスにマッチする
    name: 'NotFound',
    component: () => import('@/components/NotFound.vue'), // 遅延ロード
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // ブラウザの戻る/進むボタン → 以前のスクロール位置を復元
    if (savedPosition) {
      return savedPosition;
    }
    // 通常の画面遷移 → トップにリセット (#280)
    return { top: 0 };
  },
});

// #301: 優先順位: requiresAuth → application_guard → guideline_guard → 通常遷移
// 未ログイン状態で application_guard を評価すると user 参照で例外になるため、
// 必ずログインチェックを先に通す。
router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLogin()) {
      return next({ path: '/login' });
    }

    // #301: 既存セッションユーザーの applicationStatus 補完
    // デプロイ前にログイン済みのユーザーは localStorage に applicationStatus がないため、
    // ガード評価前に API で取得して store にセットする (1セッション1回のみ)
    await ensureApplicationStatus();

    // 審査ステータスによる画面振り分け (guideline より先に評価)
    const applicationRedirect = resolveApplicationRedirect(to);
    if (applicationRedirect && applicationRedirect !== to.path) {
      return next({ path: applicationRedirect });
    }

    if (!isGuideline()) {
      if (to.name !== 'ArticleManagement') {
        return next({ path: '/article-management' });
      }
    }
    return next();
  } else {
    return next();
  }
});

export default router;
